export const init = () => {
  // TRACKER 'PRODUCT-CONVERSION'

  const sep = AnalyticsConstants.concatenator;
  const fwk = CUBE.Analytics;
  const utils = fwk.utils.productpage;

  const tracker = new AnalyticsTracker(
    AnalyticsConstants.trackers.product.conversion
  );

  const getProductLabel = () => {
    const productName = tc_vars.product_label_displayed;
    const productNature = '%PRODUCT_NATURE%'; // TODO : tc_vars.product_nature;
    const modelId = utils.getSelectedModelId();
    return productName + sep + modelId;
  };
  const getPrice = () => utils.getSelectedPrice();
  const getTotalPrice = () =>
    utils.getSelectedPrice() * utils.getSelectedQuantity();

  // MakeYourChoice
  const makeYourChoice = new AnalyticsClickEvent(
    'makeYourChoice',
    tracker.defaultEvent()
  );
  makeYourChoice.domElement = '#modal-product-cta';
  makeYourChoice.getAction = () => {
    if (CUBE.Analytics.utils.productpage.isSizeSelected())
      return 'CheckStoreStock';
    return 'AlertEresaNoSizeSelected';
  };
  makeYourChoice.getLabel = getProductLabel;
  makeYourChoice.getValue = getPrice;
  tracker.addEvent(makeYourChoice);

  // CloseConversion
  const closeConversion = new AnalyticsClickEvent(
    'closeConversion',
    tracker.defaultEvent()
  );
  closeConversion.options.action = 'CloseConversionLayer';
  closeConversion.domContainer = '#modal-product-layout';
  closeConversion.domElement = '#close-modal-product-layout';
  closeConversion.getLabel = getProductLabel;
  closeConversion.getValue = getPrice;
  tracker.addEvent(closeConversion);

  // Colorama
  const colorama = new AnalyticsClickEvent(
    'colorama-conversion',
    tracker.defaultEvent()
  );
  colorama.delay = 50;
  colorama.options.action = 'Colorama';
  colorama.domContainer = '.product-display';
  colorama.domElement = '.thumbs-product-list .model-selection';
  colorama.getLabel = $elem => {
    const elem = $elem.length ? $elem[0] : $elem;
    if (elem.dataset && elem.dataset.modelId) {
      if (elem.dataset.labelDisplayed) {
        if (GAFramework && GAFramework.sendPageView) {
          const availability = getProductAvailability();

          CUBE.Analytics.utils.es6.reloadAnalyticsVariable(
            elem.dataset.modelId,
            'product_id_model',
            '64'
          );
          CUBE.Analytics.utils.es6.reloadAnalyticsVariable(
            elem.dataset.labelDisplayed,
            'product_label_displayed',
            '11'
          );
          CUBE.Analytics.utils.es6.reloadAnalyticsVariable(
            availability,
            'product_instock',
            '13'
          );

          GAFramework.sendPageView();
        }
      }
      return tc_vars.product_label_displayed + sep + elem.dataset.modelId;
    }
    return '';
  };
  colorama.getValue = fwk.utils.productpage.getSelectedPrice;
  tracker.addEvent(colorama);

  const getProductAvailability = () => {
    const arr = Array.from(document.querySelectorAll('.sizes__size'));
    if (
      arr.length === arr.filter(item => item.dataset.availableQuantity).length
    ) {
      return 'available';
    } else if (arr.filter(item => item.dataset.availableQuantity).length > 0) {
      return 'partialy available';
    }
    return 'unavailable';
  };

  // SelectSize
  const selectSize = new AnalyticsClickEvent(
    'selectSize',
    tracker.defaultEvent()
  );
  selectSize.delay = 50;
  selectSize.options.action = 'SelectSize';
  selectSize.domContainer = '.product-display';
  selectSize.domElement = '.sizes__wrapper--visible li';
  selectSize.getLabel = () => {
    const labelSku = $('.sizes__size--selected .sizes__info').html();
    return getProductLabel() + sep + labelSku;
  };
  selectSize.getValue = getPrice;
  selectSize.postAction(function($element) {
    // Reload weight for this sku
    const weight = $element[0].dataset.weight;
    if (weight) {
      CUBE.Analytics.utils.es6.reloadAnalyticsVariable(
        weight,
        'product_weight',
        '91'
      );
    }

    // SelectSizeWithoutValue
    if ($element[0].getAttribute('data-quantity') !== 'true') {
      const label =
        getProductLabel() +
        sep +
        $('.sizes__size--selected .sizes__info').html();
      cube.analytics.sendEvent(
        $element,
        this.getType(),
        this.getCategory(),
        'SelectSizeWithoutStock',
        label,
        this.getValue()
      );
    }
  });
  tracker.addEvent(selectSize);

  // SizeGuide
  const sizeGuide = new AnalyticsClickEvent(
    'sizeGuide',
    tracker.defaultEvent()
  );
  sizeGuide.options.action = 'ViewSizeGuide';
  sizeGuide.domContainer = '.choose-link';
  sizeGuide.domElement = 'a.cta-link';
  sizeGuide.getLabel = getProductLabel;
  sizeGuide.getValue = getPrice;
  tracker.addEvent(sizeGuide);

  // Change Quantity
  const changeQuantity = new AnalyticsClickEvent(
    'changeQuantity',
    tracker.defaultEvent()
  );
  changeQuantity.domContainer = 'div.quantity-selector';
  changeQuantity.domElement = 'button.icon';
  changeQuantity.getAction = $element =>
    $element.hasClass('icon-minus') ? 'RemoveQuantity' : 'AddQuantity';
  changeQuantity.getLabel = getProductLabel;
  changeQuantity.getValue = getPrice;
  tracker.addEvent(changeQuantity);

  // Add to cart
  const addToCart = new AnalyticsClickEvent(
    'addToCart',
    tracker.defaultEvent()
  );
  addToCart.domContainer = '.product-display';
  addToCart.domElement =
    'div.cart-buttons--online #ctaButton:not(.disabled):not(.cta-v2--disabled)';
  addToCart.options.action = 'AddToCart';
  addToCart.getLabel = getProductLabel;
  addToCart.getValue = getTotalPrice;
  addToCart.stopEvent = () =>
    $('.product-display .sizes__size--selected .sizes__info').length === 0;
  addToCart.postAction(() => {
    // Get current Enhanced ECommerce Informations
    const enhancedActual = fwk.enhanced.getActual();
    fwk.enhanced.setModelVada(enhancedActual); // set 'enhancedActual.category' with 'enhancedActual.vada{}' info (if any)
    // Update MODEL ID
    enhancedActual.id = fwk.utils.productpage.getSelectedModelId();
    // Persist it
    fwk.enhanced.set(enhancedActual);
    fwk.enhanced.persist();
  });
  tracker.addEvent(addToCart);

  // Add to cart no size selected
  const addToCartNoSizeSelected = new AnalyticsClickEvent(
    'addToCartNoSizeSelected',
    tracker.defaultEvent()
  );
  addToCartNoSizeSelected.domContainer = '.product-display';
  addToCartNoSizeSelected.domElement =
    'div.cart-buttons--online #ctaButton:not(.disabled):not(.cta-v2--disabled)';
  addToCartNoSizeSelected.options.action = 'AlertAddToCartNoSizeSelected';
  addToCartNoSizeSelected.getLabel = getProductLabel;
  addToCartNoSizeSelected.getValue = getTotalPrice;
  addToCartNoSizeSelected.stopEvent = () =>
    $('.product-display .sizes__size--selected .sizes__info').length > 0;
  tracker.addEvent(addToCartNoSizeSelected);

  // Select Delivery
  const selectDelivery = new AnalyticsClickEvent(
    'selectDelivery',
    tracker.defaultEvent()
  );
  selectDelivery.domContainer = '#shipping-information';
  selectDelivery.domElement =
    '.shipping-type .shipping-mode, .shipping-type .shipping-stores-list>li>strong';
  selectDelivery.options.action = 'SelectDelivery';
  selectDelivery.getLabel = $element => {
    const shippingMode = $element
      .closest('.shipping-type')
      .find('.shipping-mode>strong')
      .text();
    const shippingDetail = $element.is('strong') ? sep + $element.text() : '';
    return getProductLabel() + sep + shippingMode + shippingDetail;
  };
  selectDelivery.getValue = getPrice;
  tracker.addEvent(selectDelivery);

  // Modify my location
  const modifyMyLocation = new AnalyticsClickEvent(
    'modifyMyLocation',
    tracker.defaultEvent()
  );
  modifyMyLocation.options.action = 'ModifyMyLocation';
  modifyMyLocation.domContainer = '#shipping-wrapper';
  modifyMyLocation.domElement = '[data-target="#location-modal"]';
  modifyMyLocation.getLabel = getProductLabel;
  modifyMyLocation.getValue = getPrice;
  tracker.addEvent(modifyMyLocation);

  // CrossSell - Move to cart
  const eventAddToCartCrossSell = new AnalyticsEvent(
    'virtualEventAddToCartCrossSell',
    tracker.defaultEvent()
  );
  tracker.addEvent(eventAddToCartCrossSell);

  CUBE.Analytics.trackers.add(tracker);
  CUBE.Analytics.trackers.init(tracker.params.name);
};



// WEBPACK FOOTER //
// ./src/analytics/trackers/product/conversion-tracker.js